import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { grey, crunchyGreen } = colors

export const SquarePlus = ({
    background = crunchyGreen,
    color = grey,
    size = 40,
    className = 'square-plus'
}: Icon) => {
    return (
        <svg
            viewBox="0 0 40 40"
            width={size}
            height={size}
            className={className}>
            <g fill="none" fillRule="evenodd">
                <rect fill={background} width={40} height={40} rx={5} />
                <g stroke={color} strokeLinecap="round" strokeWidth={3}>
                    <path d="M20 28.8v-16M12 20.8h16" />
                </g>
            </g>
        </svg>
    )
}
